import client from '../utils/client';
import { transactionsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const transactionService = {
  transactionsList,
}

function transactionsList(pageID, perPage, startDate, endDate) {
  return client.get(transactionsUrl + '?page=' + pageID + '&per_page=' + perPage + '&start_date=' + startDate + '&end_date=' + endDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}